import { ReactNode } from 'react'

import { DEFAULT_FORMATTER_LOCALE } from '../../../../constants/defaultFormatterLocale'
import { DateTimeFormat } from '../../../../utils/DateTimeFormat'
import { FormattedElement } from '../../../elements/FormattedElement'
import { FormattedDateTimeProps } from '../../FormattedDateTime'

export interface FormattedDateProps
  extends Omit<FormattedDateTimeProps, 'options'>,
    Pick<Intl.DateTimeFormatOptions, 'dateStyle'> {
  options?: Omit<Intl.DateTimeFormatOptions, 'timeStyle'>
}

export const FormattedDate = ({
  as = 'span',
  asString = false,
  dateStyle,
  locale = DEFAULT_FORMATTER_LOCALE,
  options,
  value,
}: FormattedDateProps): ReactNode => {
  return (
    <FormattedElement as={as} asString={asString}>
      {DateTimeFormat.getFormattedDate(value, locale, { ...(options || {}), dateStyle })}
    </FormattedElement>
  )
}
